module.exports = __webpack_public_path__ + "static/img/p2.65d5e4a8.png";